import script from "./FolderGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./FolderGrid.vue?vue&type=script&setup=true&lang=ts"

import "./FolderGrid.vue?vue&type=style&index=0&id=74082ba3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74082ba3"]])

export default __exports__